import React from 'react';

export interface iRequired {
  isRequired?: boolean;
}

export const Required: FC<{ visible?: boolean }> = ({ visible }) =>
  visible ? <span className="text-danger">*</span> : null;
